import React, { Suspense } from 'react';
import ContentfulAmbassadorCard from './ContentfulAmbassadorCard/AmbassadorCard';

// Hero Components
const ContentfulDynamicHero = React.lazy(() => import('./ContentfulDynamicHero'));
const ContentfulSection = React.lazy(() => import('./ContentfulSection'));
const ContentfulLayout = React.lazy(() => import('./ContentfulLayout'));

const ContentfulAccordion = React.lazy(() => import('./ContentfulAccordion'));
const ContentfulContentBlock = React.lazy(() => import('./ContentfulContentBlock'));
const ContentfulConversionPanel = React.lazy(() => import('./ContentfulConversionPanel'));
const Contentful2ColumnLayout = React.lazy(() => import('./Contentful2ColumnLayout'));
const ContentfulCardsBlock = React.lazy(() => import('./ContentfulCardsBlock'));
const ContentfulTrustbar = React.lazy(() => import('./ContentfulTrustbar'));
const ContentfulToggle = React.lazy(() => import('./ContentfulToggle'));
const ContentfulEmbedCode = React.lazy(() => import('./ContentfulEmbedCode'));
const ContentfulRowContent = React.lazy(() => import('./ContentfulRowContent'));
const ContentfulTool = React.lazy(() => import('./ContentfulTool'));
const ContentfulInPageFeatures = React.lazy(() => import('./ContentfulInPageFeatures'));
const ContentfulRow = React.lazy(() => import('./ContentfulRow'));
const ContentfulCarousel = React.lazy(() => import('./ContentfulCarousel'));
const ContentfulTable = React.lazy(() => import('./ContentfulTable'));
const ContentfulCallToAction = React.lazy(() => import('./ContentfulCallToAction'));
const ContentfulHeader = React.lazy(() => import('./ContentfulHeader'));
const ContentfulStaticComponent = React.lazy(() => import('./ContentfulStaticComponent'));
const ContentfulSocialProofComponent = React.lazy(() => import('./ContentfulSocialProofComponent'));
const ContentfulStatsigVariantContainer = React.lazy(() => import('./ContentfulStatsig'));
const ContentfulInlineMarketingForm = React.lazy(() => import('./ContentfulInlineMarketingForm'));
const ContentfulWistiaVideo = React.lazy(() => import('./ContentfulWistiaVideo'));

export const ComponentMap = {
  Contentful2ColumnLayout,
  ContentfulAccordion,
  ContentfulCallToAction,
  ContentfulCardsBlock,
  ContentfulCarousel,
  ContentfulContentBlock,
  ContentfulConversionPanel,
  ContentfulDynamicHero,
  ContentfulEmbedCode,
  ContentfulHeader,
  ContentfulInPageFeatures,
  ContentfulLayout,
  ContentfulRow,
  ContentfulRowContent,
  ContentfulSection,
  ContentfulSocialProofComponent,
  ContentfulStaticComponent,
  ContentfulTable,
  ContentfulToggle,
  ContentfulTool,
  ContentfulTrustbar,
  ContentfulStatsigVariantContainer,
  ContentfulInlineMarketingForm,
  ContentfulWistiaVideo,
  ContentfulAmbassadorCard,
};

export const ReactLazyComponent = ({ children }) => <>{children}</>;
